// logout util function
import { userReducer } from 'src/redux/slices/userReducer.slice';
import { useSelector } from 'react-redux';
import { userProfileReducer } from 'src/redux/slices/userProfileReducer.slice';
import { profileApi } from 'src/api/profile.api';
import type { RootState } from '../redux/store';
import { useAppDispatch } from '../redux/store';
import { authReducer } from '../redux/slices/authReducer.slice';
import { useLogoutMutation } from '../api/auth.api';

export const useHandleLogout = () => {
  const dispatch = useAppDispatch();
  const [logout] = useLogoutMutation();
  const refreshToken = useSelector((state: RootState) => state.authReducer.refresh_token);

  const handleLogout = async () => {
    try {
      await logout(refreshToken).unwrap();
      // Clear user state
      dispatch(authReducer.actions.logout());
      dispatch(userReducer.actions.clearUsername());
      dispatch(userReducer.actions.clearProfilePictureKey());
      dispatch(userProfileReducer.actions.clearUserProfile());

      dispatch(profileApi.util.resetApiState());
    } catch (err) {
      console.error('Failed to update registration token during logout', err);
      // Optionally, you could handle the error state (e.g., show a notification)
      dispatch(authReducer.actions.logout());
    }
  };

  return { handleLogout };
};
